define(function(require, exports, module) {
    'use strict';

    const BaseReplacerView = require('common/base.replacer.view');
    const user = require('user');
    const config = require('config');
    const checkCounterClass = require('../../common/swiss-theme/checkConterClass/checkCounterClass');
    const $ = require('j');
    const device = require('util/device.util');
    const core = require('core');
    const BonusModel = require('../bonus-multiview-counter/bonusmultiview.bonus.model');
    const UserModel = require('./bonusmultiview.userAttributes.model');
    const dispatcher = require('bundle').dispatcher;

    module.exports = BaseReplacerView.extend({

        accessRules: {
            allow: ['user']
        },

        initialize: function(options) {
            this.options = options;
            this.model = new BonusModel();
            this.userModel = new UserModel();
        },

        subscribe: function() {
            this.listenTo(core, 'update:bonusMultiviewIndicator', this._loadBonusesInfo);
        },

        render: function() {

            this._loadBonusesInfo();
            return this;
        },

        _loadBonusesInfo: function() {
            $.when(this.model.fetch({remove: true}),this.userModel.fetch())
                .done(this._countBonus.bind(this))
                .fail(this.renderNetworkError.bind(this));
        },

        _countBonus: function() {
            const userModel = this.userModel.toJSON();
            const playerTags = userModel?.tags;
            const regStatus = userModel.regStatus;
            const isDesktop = device.formFactor === 'desktop';
            const userDetails = user.get('userDetails');
            const signupDate = userDetails?.signupDate;
            const bigCount = checkCounterClass.prototype.bigCount;

            try {
                const parsedTag = this.model.bonusMultiviewCounterSetting;

                if (!parsedTag) {
                    console.warn('Please, check Dynamic Tag {DTAG_BONUS_MULTIVIEW_COUNTER_SETTING}');
                    this.el.dataset.count = 0;
                    config.set('bonusMultiviewCounter', 0);
                    dispatcher.dispatch('notification-bonusMultiviewCounter:updated');

                    return null;
                }

                const counters = parsedTag.map(el => 0);
                parsedTag?.forEach((pageUrl, index)=> {
                    const pickPageFromTag = parsedTag.filter(el=> el.page === pageUrl.page)?.[0];

                    if (!pickPageFromTag) {
                        return null;
                    }

                    let updatedBonusList = pickPageFromTag.bonuses.map(el => el.bonusCode);
                    const availableBonuses = Object.values(this.model.attributes);
                    const checkDate = (currentDate, signupDate) => {
                        const signDate = new Date(signupDate);
                        const currDate = new Date(currentDate);
                        const delta = currDate.getTime() - signDate.getTime();
                        return delta > 0;
                    };
                    //filter player available bonus template
                    updatedBonusList.forEach(el => {
                        if (!availableBonuses.some(e => e.bonusCode === el)) {
                            updatedBonusList = updatedBonusList.filter(x => x !== el);
                        }
                    });

                    //hide global conditions with exceptions
                    if (pickPageFromTag.hideGlobalConditions?.length) {
                        pickPageFromTag.hideGlobalConditions.forEach(elem => {
                            const hasTag = playerTags?.filter(el => el.name === elem.tagName);
                            if (playerTags) {
                                console.log('no Player Tag');
                            }
                            if (!hasTag?.length) {
                                updatedBonusList = updatedBonusList.filter((element) => elem.exceptions.includes(element));
                            }
                        });
                    }

                    //hide bonus in case some condition
                    pickPageFromTag.bonuses.forEach(page => {
                        if (page.hideConditions?.length) {
                            page.hideConditions.forEach(e => {
                                if (e.tagName) {
                                    playerTags && playerTags.forEach(el => {
                                        if (el.name === e.tagName) {
                                            if (e.tagValue) {
                                                if (e.tagValue === el.value) {
                                                    updatedBonusList = updatedBonusList.filter(x => x !== page.bonusCode);
                                                }
                                            } else {
                                                if (updatedBonusList.includes(page.bonusCode)) {
                                                    updatedBonusList = updatedBonusList.filter(x => x !== page.bonusCode);
                                                }
                                            }
                                        }
                                    });
                                }
                                if (e.regStatus) {
                                    if (regStatus === e.regStatus) {
                                        if (updatedBonusList.includes(page.bonusCode)) {
                                            updatedBonusList = updatedBonusList.filter(x => x !== page.bonusCode);
                                        }
                                    }
                                }

                                if (e.signupDate) {
                                    const symbol = e.signupDate.slice(0, 1);
                                    const date = e.signupDate.slice(1, e.signupDate.length);
                                    if (symbol === '<') {
                                        if (checkDate(date, signupDate)) {
                                            updatedBonusList = updatedBonusList.filter(x => x !== page.bonusCode);
                                        }
                                    } else {
                                        if (checkDate(signupDate, date)) {
                                            updatedBonusList = updatedBonusList.filter(x => x !== page.bonusCode);
                                        }
                                    }
                                }
                            });
                        }

                        //show bonus in case some condition
                        if (page?.keepConditions?.length) {
                            page.keepConditions.forEach(e => {
                                const checkKeepCondition = () => {
                                    if (!updatedBonusList.includes(page.bonusCode)) {
                                        updatedBonusList.push(page.bonusCode);
                                    }
                                };

                                if (e.tagName) {
                                    playerTags && playerTags.forEach(el => {
                                        if (e.tagName === el.name) {
                                            if (e.value) {
                                                if (el.value === e.value) {
                                                    checkKeepCondition();
                                                }
                                            } else {
                                                checkKeepCondition();
                                            }
                                        }
                                    });
                                }

                                if (e.regStatus) {
                                    if (regStatus === e.regStatus) {
                                        checkKeepCondition();
                                    }
                                }

                                if (e.signupDate) {
                                    const symbol = e.signupDate.slice(0, 1);
                                    const date = e.signupDate.slice(1, e.signupDate.length);

                                    if (symbol === '<') {
                                        if (checkDate(date, signupDate)) {
                                            checkKeepCondition();
                                        }
                                    } else {
                                        if (checkDate(signupDate, date)) {
                                            checkKeepCondition();
                                        }
                                    }
                                }
                            });

                        }
                    });

                    counters[index] = updatedBonusList.length;

                    if (!isDesktop) {
                        const className = checkCounterClass.prototype.countClassName(updatedBonusList.length);
                        const parent = this.el.closest('.bonus-multiview-wrapper');
                        const currentPage = parent?.querySelectorAll(`[data-url='${pageUrl.page}']`)?.[0];
                        const container = document.createElement('div');
                        container.className = 'bonus-multiview-counter-child';
                        if (currentPage) {
                            currentPage.appendChild(container);
                            const $container = $(`[data-url='${pageUrl.page}'] .bonus-multiview-counter-child`);
                            $container.html(this.tmpl('bonus.counter', {
                                count: updatedBonusList.length,
                                className,
                                bigCount
                            }));
                        }
                    }
                });

                const totalCounter = counters.reduce((a, b) => a + b, 0);
                const className = checkCounterClass.prototype.countClassName(totalCounter);
                this.el.dataset.count = totalCounter;
                config.set('bonusMultiviewCounter', totalCounter);
                dispatcher.dispatch('notification-bonusMultiviewCounter:updated');

                if (!isDesktop) {
                    this.$el.html(this.tmpl('bonus.counter', {
                        count: totalCounter,
                        className,
                        bigCount
                    }));
                }
            } catch(e) {
                console.warn(e);
            }
        }
    }, {
        nameOfReplacers: [
            'BONUS_MULTIVIEW_COUNTER'
        ]
    });
});
